import React, { Component } from "react";

import "./Right.less";

export default class Right extends Component {
  render() {
    const style = {
      ...this.props.style,
      width: this.props.width,
    };
    return (
      <div
        className={"nano-panel-right " + (this.props.className || "")}
        style={style}
      >
        {this.props.children}
      </div>
    );
  };
}
